module.exports = __webpack_public_path__ + "static/10-1-eb3550e90d7f3d05393c015827e14dc8.jpg";